module.exports = __webpack_public_path__ + "static/media/marketplace2.7ac67d87.png";